import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  Renderer2,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

import { CutoffService } from "../../../services/cutoff.service";
import { TicketService } from "../../../services/ticket.service";
import { AuthService } from "../../../services/auth.service";
import { SecurityService } from "../../../services/security.service";

import { AccountManager } from "../../../model/domain/AccountManager";
import { Fund } from "../../../model/domain/Fund";
import {
  TicketCutoffResume,
  TicketCutoffOperationType,
} from "../ticket-cutoff-type.model";
import { Roles } from "../../auth/auth.role";
import { Router } from "@angular/router";
import { DialogService } from "../../../services/dialog.service";
import { faInfoCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-cutoff-default-manager-fund-dialog",
  templateUrl: "./cutoff-default-manager-fund-dialog.component.html",
  styleUrls: ["./cutoff-default-manager-fund-dialog.component.css"],
})
export class CutoffDefaultManagerFundDialogComponent implements OnInit {
  faInfoCircle = faInfoCircle;
  faTimes = faTimes;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private cutoffService: CutoffService,
    private ticketService: TicketService,
    private authService: AuthService,
    private securityService: SecurityService,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.cutoffTypeId = data.cutoffTypeId;
    this.cutoffName = data.cutoffName;
    this.isIndex = data.isIndex;
  }

  cutoffTypeId: number;
  cutoffName: string;

  isIndex: boolean;
  showException = false;
  showDefault = false;

  cutoffOperationTypeEnum = TicketCutoffOperationType;

  accountManagerListAll: AccountManager[];
  accountManagerRegisteredList: AccountManager[];
  accountManagerListToFilter: AccountManager[];
  selectedAccountManager: number;

  fundListAll: Fund[];
  fundRegisteredList: Fund[];
  fundListToFilter: Fund[];
  selectedFund: number;

  accountManagerIdList: number[] = [];

  cutoffFullList: TicketCutoffResume[];
  cutoffFilteredList: TicketCutoffResume[];

  cutoffExceptionList: TicketCutoffResume[];

  displayedColumns = [];

  displayedExceptionColmns = [
    "accountManagerName",
    "fundName",
    "defaultLimitTime",
    "currentLimitTime",
  ];

  ngOnInit() {
    if (!this.isIndex) {
      this.displayedColumns = [
        "actions",
        "accountManagerName",
        "fundName",
        "defaultLimitTime",
        "currentLimitTime",
        "request",
      ];
    } else if (this.isIndex && !this.authService.authToken.isAccountManager) {
      this.displayedColumns = [
        "accountManagerName",
        "fundName",
        "defaultLimitTime",
        "currentLimitTime",
      ];
    } else {
      this.displayedColumns = [
        "fundName",
        "defaultLimitTime",
        "currentLimitTime",
      ];
    }
    setTimeout(() =>
      this.securityService.GetAccountManagers().subscribe((res) => {
        this.accountManagerListAll = res;

        this.getResumeByCutoffType();
      })
    );
  }

  getResumeByCutoffType() {
    this.cutoffService
      .listResumeByCutoffType(this.cutoffTypeId)
      .subscribe((res) => {
        this.cutoffFullList = res;
        this.cutoffFilteredList = this.cutoffFullList;

        if (this.cutoffFullList.length > 0) {
          this.showDefault = true;
        }

        for (const item of this.cutoffFullList) {
          this.accountManagerIdList.push(item.accountManagerId);

          const accountManager = this.accountManagerListAll.find(
            (x) => x.id === item.accountManagerId
          );

          if (this.accountManagerRegisteredList == null) {
            this.accountManagerRegisteredList = [];
          }
          if (
            !this.accountManagerRegisteredList.some(
              (x) => x.id === accountManager.id
            )
          ) {
            this.accountManagerRegisteredList.push(accountManager);
          }

          item.accountManagerName = accountManager.name;
        }

        this.accountManagerListToFilter = this.accountManagerRegisteredList;

        this.ticketService
          .getFundsByAccountManagerIdList(this.accountManagerIdList)
          .subscribe((result) => {
            this.fundListAll = result;
            for (const item of this.cutoffFullList) {
              if (item.fundId != null) {
                const fund = this.fundListAll.find((x) => x.id === item.fundId);

                if (this.fundRegisteredList == null) {
                  this.fundRegisteredList = [];
                }

                this.fundRegisteredList.push(fund);

                item.fundName = fund.name;
              } else {
                item.fundName = "(todos)";
              }
            }
            this.fundListToFilter = this.fundRegisteredList;
          });

        if (this.isIndex) {
          this.cutoffService
            .getCutoffExceptionByCutoffTypeAccManagerFund(
              this.cutoffTypeId,
              null,
              null
            )
            .subscribe((resException) => {
              this.cutoffExceptionList = resException;

              if (this.cutoffExceptionList.length > 0) {
                this.showException = true;
              }
              for (const item of this.cutoffExceptionList) {
                this.accountManagerIdList.push(item.accountManagerId);
                const accountManager = this.accountManagerListAll.find(
                  (x) => x.id === item.accountManagerId
                );

                if (this.accountManagerRegisteredList == null) {
                  this.accountManagerRegisteredList = [];
                }
                if (
                  !this.accountManagerRegisteredList.some(
                    (x) => x.id === accountManager.id
                  )
                ) {
                  this.accountManagerRegisteredList.push(accountManager);
                }

                item.accountManagerName = accountManager.name;
              }

              this.accountManagerListToFilter =
                this.accountManagerRegisteredList;

              this.ticketService
                .getFundsByAccountManagerIdList(this.accountManagerIdList)
                .subscribe((result) => {
                  this.fundListAll = result;
                  for (const item of this.cutoffExceptionList) {
                    if (item.fundId != null) {
                      const fund = this.fundListAll.find(
                        (x) => x.id === item.fundId
                      );

                      if (this.fundRegisteredList == null) {
                        this.fundRegisteredList = [];
                      }

                      this.fundRegisteredList.push(fund);

                      item.fundName = fund.name;
                    } else {
                      item.fundName = "(todos)";
                    }
                  }
                  this.fundListToFilter = this.fundRegisteredList;
                });
            });
        }
      });
  }

  filterResultByAccountManager() {
    if (this.selectedAccountManager != null && this.selectedFund == null) {
      const accountManagerSelectedId = this.selectedAccountManager;
      this.cutoffFilteredList = this.cutoffFullList.filter(function (obj) {
        return obj.accountManagerId === accountManagerSelectedId;
      });
    } else if (
      this.selectedAccountManager != null &&
      this.selectedFund != null
    ) {
      const fundSelectedId = this.selectedFund;
      const accountManagerSelectedId = this.selectedAccountManager;
      this.cutoffFilteredList = this.cutoffFullList.filter(function (obj) {
        return (
          obj.fundId === fundSelectedId &&
          obj.accountManagerId === accountManagerSelectedId
        );
      });
    } else {
      if (this.selectedFund == null) {
        this.cutoffFilteredList = this.cutoffFullList;
      } else {
        this.filterResultByFund();
      }
    }

    this.removeFundFilterByAccountManager(this.selectedAccountManager);
  }

  filterResultByFund() {
    if (this.selectedFund != null && this.selectedAccountManager == null) {
      const fundSelectedId = this.selectedFund;
      this.cutoffFilteredList = this.cutoffFullList.filter(function (obj) {
        return obj.fundId === fundSelectedId;
      });
    } else if (
      this.selectedFund != null &&
      this.selectedAccountManager != null
    ) {
      const fundSelectedId = this.selectedFund;
      const accountManagerSelectedId = this.selectedAccountManager;
      this.cutoffFilteredList = this.cutoffFullList.filter(function (obj) {
        return (
          obj.fundId === fundSelectedId &&
          obj.accountManagerId === accountManagerSelectedId
        );
      });
    } else {
      if (this.selectedAccountManager == null) {
        this.cutoffFilteredList = this.cutoffFullList;
      } else {
        this.filterResultByAccountManager();
      }
    }

    this.removeAccountManagerFilterByFund(this.selectedFund);
  }

  removeFundFilterByAccountManager(accountManagerId: number) {
    if (this.fundListToFilter != null) {
      if (accountManagerId > 0 || accountManagerId !== null) {
        this.fundListToFilter = this.fundListToFilter.filter(function (obj) {
          return obj.accountManagerId === accountManagerId;
        });
      } else {
        this.fundListToFilter = this.fundRegisteredList;
      }
    }
  }

  removeAccountManagerFilterByFund(fundId: number) {
    if (fundId > 0 || fundId !== null) {
      const accountManagerToShow = this.fundListToFilter.find(
        (x) => x.id === fundId
      ).accountManagerId;
      this.accountManagerListToFilter = [];
      this.accountManagerListToFilter.push(
        this.accountManagerRegisteredList.find(
          (x) => x.id === accountManagerToShow
        )
      );
    } else {
      this.accountManagerListToFilter = this.accountManagerRegisteredList;
    }
  }

  canChangeCutoffDefault(): boolean {
    return this.authService.hasRole(Roles.ChangeDefaultLimitTime);
  }

  get canChangeLimitTime(): boolean {
    return this.authService.hasRole(Roles.ChangeLimitTime);
  }

  openTimeUpdate(id: number = null) {
    if (id === null) {
      this.router.navigate(["/cutoff/cutoff-default-update"]);
    } else {
      this.router.navigate(["/cutoff/cutoff-default-update", id]);
    }
  }

  openCreateCutoff(
    cutoffOperationType: number = null,
    cutoffTypeId: number = null,
    accountManagerId: number = null,
    fundId: number = null
  ) {
    const params: any = {};

    if (cutoffOperationType) {
      params.cutoffOperationType = cutoffOperationType;
    }
    if (cutoffTypeId) {
      params.cutoffTypeId = cutoffTypeId;
    }
    if (accountManagerId) {
      params.accountManagerId = accountManagerId;
    }
    if (fundId) {
      params.fundId = fundId;
    }

    this.router.navigate(["/cutoff/cutoff-create/", params]);
  }

  showActions() {
    return !this.isIndex || !this.authService.authToken.isAccountManager;
  }
}
